module.exports = __webpack_public_path__ + "e1fddf5e3e801e5a42594d84c88edda0.MP3";